function view (path) {
  return () => import(/* webpackChunkName: 'audit-v1' */ '@/views/audit/' + path).then(m => m.default || m) // eslint-disable-line prefer-template
}

const RAudit = [
  {
    path: '/audit/dashboard',
    component: view('Dashboard'),
    name: 'audit.dashboard',
    authorizedRole: 'audit'
  },
  {
    path: '/audit/payment-vouchers/:audit?',
    component: view('PaymentVouchers'),
    name: 'audit.payment-vouchers',
    authorizedRole: 'audit',
    meta: {
      breadcrumb: [
        {
          text: 'Audit'
        },
        {
          text: 'Payment Vouchers',
          active: true
        }
      ]
    }
  }
]

export default RAudit
